(() => {
  const section = document.querySelector('[data-product-section][data-product-handle]');
  if (!section) return;
  const entry = window.RespireProductReviews;
  if (!entry || !entry.count) return;

  const escapeHtml = (value = '') => String(value).replace(/[&<>"']/g, (character) => ({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
  })[character]);
  const formatDate = (value) => {
    const date = new Date(`${value}T12:00:00`);
    return Number.isNaN(date.getTime()) ? value : new Intl.DateTimeFormat('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' }).format(date);
  };
  const stars = (rating) => '★'.repeat(Math.max(0, Math.min(5, Number(rating) || 0))) + '☆'.repeat(Math.max(0, 5 - (Number(rating) || 0)));

  const topRating = section.querySelector('[data-product-rating]');
  if (topRating) {
    topRating.innerHTML = `<span aria-hidden="true">★★★★★</span> ${entry.rating} / 5 - ${entry.count} AVIS`;
    topRating.setAttribute('aria-label', `${entry.rating} sur 5, ${entry.count} avis`);
    topRating.hidden = false;
  }

  const reviewSection = section.querySelector('[data-product-reviews]');
  if (!reviewSection) return;
  reviewSection.hidden = false;
  const score = reviewSection.querySelector('[data-review-score]');
  if (score) score.innerHTML = `<span aria-hidden="true">★★★★★</span><strong>${entry.rating} / 5</strong><p>Basé sur ${entry.count} avis</p>`;
  const list = reviewSection.querySelector('[data-review-list]');
  if (!list) return;

  let visible = 5;
  const render = () => {
    list.innerHTML = entry.reviews.slice(0, visible).map((review) => `<article class="product-review">
      <div class="product-review__head"><span class="product-review__stars" aria-label="${review.rating} sur 5">${stars(review.rating)}</span><time datetime="${escapeHtml(review.date)}">${escapeHtml(formatDate(review.date))}</time></div>
      <h3>${escapeHtml(review.title || 'Avis client')}</h3>
      <p>${escapeHtml(review.body)}</p>
      <footer><strong>${escapeHtml(review.name || 'Client')}</strong>${review.verified ? '<span>✓ Acheteur vérifié</span>' : ''}${review.recommended ? '<span>Je recommande ce produit</span>' : ''}</footer>
    </article>`).join('');
    let more = reviewSection.querySelector('[data-review-more]');
    if (visible < entry.reviews.length) {
      if (!more) {
        more = document.createElement('button');
        more.type = 'button';
        more.className = 'button button--outline product-reviews__more';
        more.dataset.reviewMore = '';
        more.textContent = 'AFFICHER PLUS';
        list.after(more);
        more.addEventListener('click', () => { visible += 5; render(); });
      }
    } else if (more) more.remove();
  };
  render();
})();
